<template>

  <div id="page-new-producto" class="vx-card p-6">

    <vx-card card-border class="mb-4" title="Detalle del producto" title-color="dark" collapseAction>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Sector</span>
          </div>
          <div>
            <v-select disabled class="w-full" 
              v-model="producto.valSector" 
              :options="sectoresActivos" 
              :selectable="option => option.activo === true"
              label="nombre"
              :reduce="id => `/api/val_sectors/${id.id}`" 
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Operador</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.operador" name="operador"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Tipo cliente</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.tipoCliente" name="tipoCliente"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Tipo producto</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.tipoProducto" name="tipoProducto"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Producto</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.producto" name="producto"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Promoción</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.promocion" name="promocion"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Importe sin promoción</span>
          </div>
          <div>
            <currency-input disabled 
              currency="EUR" 
              auto-decimal-mode: true
              name="importeSinPromocion"  
              class="vs-inputx vs-input--input normal" 
              v-model="producto.importeSinPromocion"
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Importe con promoción</span>
          </div>
          <div>
            <currency-input disabled 
              currency="EUR" 
              auto-decimal-mode: true
              name="importeConPromocion"  
              class="vs-inputx vs-input--input normal" 
              v-model="producto.importeConPromocion"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Tipo tarjeta</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.tipoTarjeta" name="tipoTarjeta"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Sección</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.seccion" name="seccion"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Codigo producto</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.codigoPrincipal" name="codigoPrincipal" />
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Códigos productos asociados</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.asociados" name="asociados" />
          </div>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Producto único</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.unico" name="unico"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <div>
            <span>Orden</span>
          </div>
          <div>
            <vs-input disabled class="w-full" v-model="producto.orden" name="orden" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
        <div>
          <span>Caracteristicas del producto</span>
        </div>
          <vs-textarea disabled class="w-full" name="caracteristicas" v-model="producto.caracteristicas" height="120px"/>
        </div>
      </div>

      <!-- Botóns -->
      <div class="vx-row" id="account-manage-buttons">
        <div class="vx-col sm:w-1/2 flex w-full">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{ name: 'valProductosEditar', params: { productoId: $route.params.productoId }}">Editar</vs-button>
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Borrar</vs-button>
        </div>
        <div class="vx-col sm:w-1/2 flex w-full justify-end">
          <vs-button color="warning" type="border" :to="{ name: 'valProductos' }">Cancelar</vs-button>
        </div>
      </div>
    </vx-card>

  </div>

</template>

<script>
import valProductosStore from '@/store/configuracion/val-productos/index.js'
import valSectoresStore from '@/store/configuracion/val-sectores/index.js'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  data () {
    return {
      sectoresActivos: [],
      producto: null
    }
  },
  computed: {
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar el producto "${this.producto.producto}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('valProductosStore/deleteProducto', this.producto.id)
        .then(()   => { this.$router.push({name: 'valProductos'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Producto eliminado',
        text: 'El producto ha sido eliminado'
      })
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

    if (!valProductosStore.isRegistered) {
      this.$store.registerModule('valProductosStore', valProductosStore)
      valProductosStore.isRegistered = true
    }

    const productoId = this.$route.params.productoId
    const idx = this.$store.state.valProductosStore.productos.findIndex((u) => u.id == productoId)
    this.producto = this.$store.state.valProductosStore.productos[idx]

    if (!valSectoresStore.isRegistered) {
      this.$store.registerModule('valSectoresStore', valSectoresStore)
      valSectoresStore.isRegistered = true
    }
    await this.$store.dispatch('valSectoresStore/getSectores')
      .then(() => {
        // Recorremos os sectores e se están activos ou se teñen o mesmo id que o que ten asociado o producto engadímolas ao combo
        this.$store.state.valSectoresStore.sectores.forEach(element => {
          if (element.activo || element.id == this.producto.valSector.id) this.sectoresActivos.push(element)
        })
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
      .catch((error) => {
        console.log(error)
        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      })
  }
}

</script>